import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';
import { errorMessage } from '../../util/ConfirmAlertUtil';
import { importInstituicaoFile } from './api-instituicao';

const useStyles = makeStyles({
    container: {
        padding: '20px',
    },
    title: {
        padding: '20px',
    },
    loading: {
        marginRight: '10px',
        marginLeft: '10px'
    }
});

export default function InstituicaoImport() {
    const classes = useStyles();
    const [fileUsers, setFileUsers] = useState();
    const [message, setMessage] = useState();
    const [isLoading, setIsLoading] = useState(false);

    const handleFileSelected = event => {
        setFileUsers(event.target.files[0]);
    }

    const handleUpload = () => {
        const fileFormData = new FormData();
        fileFormData.append('file', fileUsers);
        setIsLoading(true);
        importInstituicaoFile(fileFormData).then((data) => {
            if (data) {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    setMessage(data.message);
                }
            }
            setIsLoading(false);
        })
    }

    return (
        <Container className={classes.container} component={Paper}>
            <Typography className={classes.title} variant="h5">
                Importar Instituições
            </Typography>
            <Grid container justifyContent="space-around">
                <input type="file" onChange={handleFileSelected} />

                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleUpload}
                    disabled={isLoading}
                >
                    {isLoading && <CircularProgress className={classes.loading} color="primary" size={20} />}
                    Fazer Upload
                </Button>

            </Grid>
            <Typography className={classes.title} variant="h5">
                {message}
            </Typography>
        </Container>
    );
}